<template>
    <div>
        <compFormEdit class="margin-top-15 editform" :formdata="getCurrency" v-model="formData" :labelWidth="0" :col="1"></compFormEdit>
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{$t('global.common.save',{defaultValue:'保存'})}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
        </div>
    </div>
</template>

<script>
import {
    HttpGetfindCurrency,
    HttpSaveCurrency,
    HttpGetCurrencyRate
} from '@/service/products/allproducts'
export default {
    props:['activeid'],
    data(){
        return {
            formData:{},
            arr:[],
        }
    },
    components:{
        compFormEdit: () => import("@components/templates/formedit"),
    },
    created(){
        // 第一次请求
        this.getCurrencyDetail()
    },
    computed:{
        getCurrency(){
            return [
                
                {
					// label: "",
					key: "USD",
                    required: false,
                    children(h) {
						return <span slot='append' style="width:100px" class="padding-left-10 padding-right-10">{this.$t('erp.product.usd', { defaultValue: 'USD(美元)' })}</span>
					},
                },
                {
					// label: "",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:this.$t('erp.product.foblabel',{defaultValue:'使用当前汇率自动将美元转换其他币种'}),
                        trueValue:'US'
                    },
                    on:{
                        'on-change':(val)=>{
                            this.getHttpCurrency(val)
                        }
                    }
				},
                {
					// label: "",
					key: "EUR",
                    required: false,
                    children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('erp.product.eur', { defaultValue: 'EUR(欧元)' })}</span>
					},
                },
                {
					// label: "",
					key: "JPY",
                    required: false,
                    children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('erp.product.jpy', { defaultValue: 'JPY(日元)' })}</span>
					},
                },
                {
					// label: "",
					key: "CAD",
                    required: false,
                    children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('erp.product.cad', { defaultValue: 'CAD(加拿大元)' })}</span>
					},
                },
                {
					// label: "",
					key: "GBP",
                    required: false,
                    children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('erp.product.gbp', { defaultValue: 'GBP(英镑)' })}</span>
					},
                },
                {
					// label: "",
					key: "MXN",
                    required: false,
                    children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('erp.product.mxn', { defaultValue: 'MXN(墨西哥元)' })}</span>
					},
                },
                {
					// label: "",
					key: "CNY",
                    required: false,
                    children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('erp.product.cny', { defaultValue: 'CNY(人民币)' })}</span>
					},
                },
                {
					// label: "",
					key: "AUD",
                    required: false,
                    children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('erp.product.aud', { defaultValue: 'AUD(澳大利亚元)' })}</span>
					},
                },
                {
					key: "SEK",
                    required: false,
                    children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('erp.product.sek', { defaultValue: 'SEK(克朗)' })}</span>
					},
                },
                {
					key: "PLN",
                    required: false,
                    children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('erp.product.pln', { defaultValue: 'PLN(波兰兹罗提)' })}</span>
					},
                },
            ]
        }
    },
    methods:{
        getCurrencyDetail(){
            HttpGetfindCurrency({
                id:this.activeid,
            }).then(res=>{
                // console.log(res)
                let datas = {};
                this.arr = res.data.currencyList
                this.arr.map(item=>{
                    datas[item.currency] = item.finance
                })
                // console.log(datas)
                this.formData = datas
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        getHttpCurrency(val){
            // 勾选就请求后端接口获取汇率
            if(val == 'US'){
                for (let key in this.formData){
                    this.arr.map(item=>{
                        if(item.currency == key){
                            item.finance = this.formData[key]
                        }
                    })
                }
                // console.log(this.arr)
                HttpGetCurrencyRate({
                    orgId:global.SYSID,
                    productId:this.activeid,
                    currencyList:this.arr
                }).then(res=>{
                    // console.log(res)
                    let datas = {};
                    this.arr = res.data.currencyList
                    this.arr.map(item=>{
                        datas[item.currency] = item.finance
                    })
                    datas.countryCode = 'US'
                    // console.log(datas)
                    this.formData = datas
                },err=>{

                })
            }else{
                this.formData.EUR = ""
                this.formData.JPY = ""
                this.formData.CAD = ""
                this.formData.GBP = ""
                this.formData.MXN = ""
                this.formData.CNY = ""
                this.formData.AUD = ""
                this.formData.SEK = ""
                this.formData.PLN = ""
            }
        },
        submit(){
            for (let key in this.formData){
                this.arr.map(item=>{
                    if(item.currency == key){
                        item.finance = this.formData[key]
                    }
                })
            }
            HttpSaveCurrency({
                orgId:global.SYSID,
                productId:this.activeid,
                currencyList:this.arr
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.$emit('on-close')
            },err=>{

            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>